import { ReactNode, useEffect, useState } from "react";
import { IntlProvider } from "react-intl";

import English from "../../localization/messages/en-US.json";
import Czech from "../../localization/messages/cs-CZ.json";
import German from "../../localization/messages/de-DE.json";
import Italian from "../../localization/messages/it-IT.json";
import Spanish from "../../localization/messages/es-ES.json";
import French from "../../localization/messages/fr-FR.json";
import Dutch from "../../localization/messages/nl-NL.json";
import Polish from "../../localization/messages/pl-PL.json";
import PortugueseBR from "../../localization/messages/pt-BR.json";
import { useAppSelector } from "../../app/hooks";
import { selectLanguage } from "../../services/localizationSlice";
import { TranslationsRecord } from "../../types/TranslationsRecord";

interface Props {
  children: ReactNode;
}

const translations: Record<string, TranslationsRecord> = {
  "en-US": English,
  "cs-CZ": Czech,
  "de-DE": German,
  "it-IT": Italian,
  "es-ES": Spanish,
  "fr-FR": French,
  "nl-NL": Dutch,
  "pl-PL": Polish,
  "pt-BR": PortugueseBR,
};

const LocalizationWrapper = ({ children }: Props) => {
  const language = useAppSelector(selectLanguage);
  const [messages, setMessages] = useState<TranslationsRecord>(English);

  useEffect(() => {
    // Pick translation or fallback to English
    const selected = translations[language.cultureName] || English;
    setMessages(selected);
  }, [language.cultureName]);

  const locale = language.cultureName || "en-US";

  return (
    <IntlProvider messages={messages} locale={locale} defaultLocale="en-US">
      {children}
    </IntlProvider>
  );
};

export default LocalizationWrapper;